import React, { useState, useEffect, useRef } from "react";
import ActionButtonGroup from "../../../Common/CommonButtons/ActionButtonGroup";
import NavigationButtons from "../../../Common/CommonButtons/NavigationButtons";
import { Button, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import AccountMasterHelp from "../../../Helper/AccountMasterHelp";
import { useNavigate, useLocation } from "react-router-dom";
import axios, { isCancel } from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UserAuditInfo from "../../../Common/UserAuditInfo/UserAuditInfo"
import {
  TextField,
  Grid,
  Box,
  TextareaAutosize,Typography
} from '@mui/material';
import SaveUpdateSpinner from "../../../Common/Spinners/SaveUpdateSpinner";
import Swal from "sweetalert2";
import LetterHeadReprt from "./LetterHeadPrint";

const API_URL = process.env.REACT_APP_API;

var partyCode = "";
var partyName = "";
var unitCode = "";
var unitName = "";

const LetterHead = () => {
  const [updateButtonClicked, setUpdateButtonClicked] = useState(false);
  const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  const [addOneButtonEnabled, setAddOneButtonEnabled] = useState(false);
  const [saveButtonEnabled, setSaveButtonEnabled] = useState(true);
  const [cancelButtonEnabled, setCancelButtonEnabled] = useState(true);
  const [editButtonEnabled, setEditButtonEnabled] = useState(false);
  const [deleteButtonEnabled, setDeleteButtonEnabled] = useState(false);
  const [backButtonEnabled, setBackButtonEnabled] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [highlightedButton, setHighlightedButton] = useState(null);
  const [cancelButtonClicked, setCancelButtonClicked] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [party, setParty] = useState("");
  const [unit, setUnit] = useState("");
  const companyCode = sessionStorage.getItem("Company_Code");
  const yearCode = sessionStorage.getItem("Year_Code");
  const navigate = useNavigate();
  const [party_Name, setPartyName] = useState("");
  const [gradeRows, setGradeRows] = useState([
  {
    grade: "",
    Quantity: "",
    Rate: "",
    Advance: "",
    Season: "",
  },
]);

  const [isLoading, setIsLoading] = useState(false);

  // Grade dropdown - sourced from System Master, type 'S' (sugar grades) only
  // (same source as the Transfer Letter's grade dropdown)
  const [gradeOptions, setGradeOptions] = useState([]);

  useEffect(() => {
    if (!companyCode) return;
    fetch(`${API_URL}/getall-SystemMaster?Company_Code=${companyCode}`)
      .then((res) => res.json())
      .then((data) => {
        const list = Array.isArray(data) ? data : [];
        setGradeOptions(list.filter((r) => r.System_Type === "S"));
      })
      .catch(() => setGradeOptions([]));
  }, [companyCode]);

  const isDisabled = !isEditing && addOneButtonEnabled;

  const acCodeRef = useRef(null);
  const changeNoRef = useRef(null);
  //In utility page record doubleClicked that recod show for edit functionality
  const location = useLocation();
  const selectedRecord = location.state?.selectedRecord;
  const initialFormData = {
    Letter_No: "",
    Letter_Date: new Date().toISOString().split("T")[0],
    Mill_code: 0.0,
    Ref_no: "",
    
    Subject: "Sugar trade confirmation and agreement, sold by you.",
    Commodity: "White Crystal Sugar",
    Specification: "Free from impurities. Packed in 50 kg PP Bags",
    grade: "",
    Quantity: 0,
    Rate: 0.00,
    Delivery_terms: "Ex-Mill",
    PaymentDue_Date: "",
    Lifting_Date: "",
    mc :0,
    Company_Code: parseInt(companyCode),
    Created_By: "",
    Modified_By: "",
    Advance: 0.00,
    ADDRESS :"",
    CITY : "",
    PINCODE : "",
    GST_no : "",
    District : "",
    State : "",
    gov_millcode : 0,
    Note: "",
    Mill2_Code: "",
    Mill2_Accoid: "",
    Mill2_Name: "",
    Mill2_GovCode: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (isCancel) {
      if (changeNoRef.current) {
        changeNoRef.current.focus();
      }
    }
  }, [isEditing, isCancel]);

  // Handle change for all inputs
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => {
      const updatedFormData = { ...prevState, [name]: value };
      return updatedFormData;
    });
  };

  const handleParty = async (code, accoid, name) => {
    setParty(code);
    setPartyName(name); // Party Name shows the full legal name (used on the printed letter)

    const updateApiUrl = `${API_URL}/getting_letterpartyDetails?CompanyCode=${companyCode}&Ac_Code=${code}`;

    const response = await axios.get(updateApiUrl);

    setFormData({
      ...formData,
      Mill_code: code,
      mc: accoid,
      AC_NAME : name,

      ADDRESS: response.data.Address_E ?? "",
      CITY: response.data.cityname ?? "",
      PINCODE: response.data.Pincode ?? "",
      GST_no: response.data.Gst_No ?? "",
      State: response.data.State_Name ?? "",
      gov_millcode :response.data.gov_millcode ?? "",

    });
  };

  // Separate, optional Mill selector - after Party, distinct from the
  // Party/Mill_code field above (Party can be a trader/party different
  // from the physical mill fulfilling the letter).
  const handleMill2 = (
    Ac_Code,
    accoid,
    Ac_Name_E,
    Mobile_No,
    Gst_No,
    TDSApplicable,
    GSTStateCode,
    cityname,
    State_Name,
    EbuyDailyLimit,
    EbuyDailySellLimit,
    Short_Name,
    gov_millcode
  ) => {
    setFormData((prev) => ({
      ...prev,
      Mill2_Code: Ac_Code,
      Mill2_Accoid: accoid,
      Mill2_Name: Short_Name || Ac_Name_E,
      Mill2_GovCode: gov_millcode,
    }));
  };

  const fetchLastRecord = () => {
    fetch(
      `${API_URL}/get-next-letterHead-no?Company_Code=${companyCode}`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch last record");
        }
        return response.json();
      })
      .then((data) => {
        setFormData((prevState) => ({
          ...prevState,
          Letter_No: parseInt(data.next_doc_no),
        }));
      })
      .catch((error) => {
        console.error("Error fetching last record:", error);
      });
  };

  const handleAddOne = () => {
    setAddOneButtonEnabled(false);
    setSaveButtonEnabled(true);
    setCancelButtonEnabled(true);
    setEditButtonEnabled(false);
    setDeleteButtonEnabled(false);
    setIsEditing(true);
    fetchLastRecord();
    setFormData(initialFormData);
    partyCode = "";
    partyName = "";
    setParty("")
    setPartyName("")
    setGradeRows([
    {
      grade: "",
      Quantity: "",
      Rate: "",
      Advance: "",
      Season: "",
    },
  ]);
    setTimeout(() => {
      acCodeRef.current?.focus();
    }, 0);
  };

  
const handleSaveOrUpdate = async () => {
  setIsLoading(true);

  try {
    // Remove letterid without modifying React state
    const { letterid, ...letterData } = formData;

    // Create JSON payload
    const payload = {
      ...letterData,

      // Multiple Grade, Quantity, Rate, Advance, Season rows
      gradeDetails: gradeRows.map((row) => ({
        grade: row.grade ?? "",
        Quantity: Number(row.Quantity) || 0,
        Rate: Number(row.Rate) || 0,
        Advance: Number(row.Advance) || 0,
        Season: row.Season ?? "",
      })),
    };

    console.log(
      "Saving LetterHead JSON:",
      JSON.stringify(payload, null, 2)
    );

    const url = isEditMode
      ? `${API_URL}/update-LetterHead`
      : `${API_URL}/insert-LetterHead`;

    const response = isEditMode
      ? await axios.put(url, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        })
      : await axios.post(url, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        });

    console.log("API Response:", response.data);

    await Swal.fire({
      title: "Success!",
      text: isEditMode
        ? "Record Updated Successfully!"
        : "Record Created Successfully!",
      icon: "success",
      confirmButtonText: "OK",
    });

    setIsEditMode(false);
    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);
    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);
    setUpdateButtonClicked(true);
    setIsEditing(false);

  } catch (error) {
    console.error(
      "Error saving/updating LetterHead:",
      error.response?.data || error.message
    );

    Swal.fire({
      title: "Error!",
      text:
        error.response?.data?.error ||
        "Unable to save LetterHead.",
      icon: "error",
      confirmButtonText: "OK",
    });

  } finally {
    setIsLoading(false);
  }
};


  const handleEdit = () => {
    setIsEditMode(true);
    setAddOneButtonEnabled(false);
    setSaveButtonEnabled(true);
    setCancelButtonEnabled(true);
    setEditButtonEnabled(false);
    setDeleteButtonEnabled(false);
    setBackButtonEnabled(true);
    setIsEditing(true);
  };
  
const handleCancel = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/getLast_LetterHead`,
      {
        params: {
          Company_Code: companyCode,
        },
      }
    );

    const data = response.data;
    const lastLetterData = data.lastLetterData;

    if (lastLetterData) {
      // ===================================
      // PARTY DETAILS
      // ===================================

      partyCode = lastLetterData.AC_CODE;

      setParty(lastLetterData.Mill_code);
      setPartyName(lastLetterData.AC_NAME || "");

      // ===================================
      // MAIN LETTERHEAD DETAILS
      // ===================================

      setFormData((prevData) => ({
        ...prevData,
        ...lastLetterData,
      }));

      // ===================================
      // MULTIPLE GRADE DETAILS
      // ===================================

      let gradeDetails = [];

      try {
        // Supports JSON string or array
        const rawGradeDetails =
          lastLetterData.GradeDetailsJson ??
          lastLetterData.gradeDetails ??
          [];

        gradeDetails =
          typeof rawGradeDetails === "string"
            ? JSON.parse(rawGradeDetails)
            : rawGradeDetails;

        if (!Array.isArray(gradeDetails)) {
          gradeDetails = [];
        }
      } catch (error) {
        console.error(
          "Error parsing grade details:",
          error
        );
        gradeDetails = [];
      }

      // Display saved grade rows
      if (gradeDetails.length > 0) {
        setGradeRows(
          gradeDetails.map((row) => ({
            grade: row.grade ?? "",
            Quantity: row.Quantity ?? "",
            Rate: row.Rate ?? "",
            Advance: row.Advance ?? "",
            Season: row.Season ?? "",
          }))
        );
      } else {
        // Support existing records with one grade
        setGradeRows([
          {
            grade: lastLetterData.grade ?? "",
            Quantity: lastLetterData.Quantity ?? "",
            Rate: lastLetterData.Rate ?? "",
            Advance: lastLetterData.Advance ?? "",
            Season: lastLetterData.Season ?? "",
          },
        ]);
      }
    }

  } catch (error) {
    console.error(
      "Error fetching latest LetterHead:",
      error
    );

  } finally {
    // ===================================
    // RESET BUTTON STATES
    // ===================================

    setIsEditing(false);
    setIsEditMode(false);

    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);

    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);
    setCancelButtonClicked(true);
  }
};


  const handleDelete = async () => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: `Do you really want to delete Doc No: ${formData.Letter_No}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        cancelButtonText: "Cancel",
        confirmButtonText: "Delete",
        reverseButtons: true,
        focusCancel: true,
      });

      if (result.isConfirmed) {
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setIsLoading(true);

        const deleteApiUrl = `${API_URL}/delete-LetterHead?DOC_NO=${formData.Letter_No}&Company_Code=${companyCode}`;
        const deleteResponse = await axios.delete(deleteApiUrl);

        if (deleteResponse.status === 200) {
          if (deleteResponse.data) {
            Swal.fire({
              title: "Deleted!",
              text: "Record deleted successfully!",
              icon: "success",
              confirmButtonText: "OK",
            });
            handleCancel();
          }
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to delete the record.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } else {
        Swal.fire({
          title: "Cancelled",
          text: "Your record is safe 🙂",
          icon: "info",
          confirmButtonText: "OK",
        });
        console.log("Deletion cancelled");
      }
    } catch (error) {
      console.error("Error during API call:", error);
      Swal.fire({
        title: "Error",
        text: `There was an error during the deletion: ${error.message}`,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/letterHeadUtility");
  };

  //Handle Record DoubleCliked in Utility Page Show that record for Edit

const handlerecordDoubleClicked = async () => {
  try {
    debugger
    const response = await axios.get(
      `${API_URL}/getByDocNo_LetterHead`,
      {
        params: {
          Company_Code: companyCode,
          DOC_NO: selectedRecord.Letter_No,
        },
      }
    );

    const data = response.data;
    const letterData = data.letterData;

    if (!letterData) {
      console.error("LetterHead record not found");
      return;
    }

    // ===================================
    // PARTY DETAILS
    // ===================================

    partyCode = letterData.Mill_code;

    setParty(letterData.Mill_code);
    setPartyName(letterData.AC_NAME || "");

    // ===================================
    // MAIN LETTERHEAD DATA
    // ===================================

    setFormData((prevData) => ({
      ...prevData,
      ...letterData,
    }));

    // ===================================
    // MULTIPLE GRADE DETAILS
    // ===================================

    let gradeDetails = [];

    try {
      const rawGradeDetails =
        letterData.GradeDetailsJson ??
        letterData.gradeDetails ??
        [];

      gradeDetails =
        typeof rawGradeDetails === "string"
          ? JSON.parse(rawGradeDetails)
          : rawGradeDetails;

      if (!Array.isArray(gradeDetails)) {
        gradeDetails = [];
      }

    } catch (error) {
      console.error(
        "Error parsing GradeDetailsJson:",
        error
      );
      gradeDetails = [];
    }

    if (gradeDetails.length > 0) {
      setGradeRows(
        gradeDetails.map((row) => ({
          grade: row.grade ?? "",
          Quantity: row.Quantity ?? "",
          Rate: row.Rate ?? "",
          Advance: row.Advance ?? "",
          Season: row.Season ?? "",
        }))
      );
    } else {
      // Old LetterHead records with single grade
      setGradeRows([
        {
          grade: letterData.grade ?? "",
          Quantity: letterData.Quantity ?? "",
          Rate: letterData.Rate ?? "",
          Advance: letterData.Advance ?? "",
          Season: letterData.Season ?? "",
        },
      ]);
    }

    console.log("LetterHead Data:", letterData);
    console.log("Grade Details:", gradeDetails);

  } catch (error) {
    console.error(
      "Error fetching LetterHead data:",
      error.response?.data || error.message
    );

  } finally {
    // ===================================
    // BUTTON STATES
    // ===================================

    setIsEditMode(false);
    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);
    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);
    setUpdateButtonClicked(true);
    setIsEditing(false);
  }
};


  useEffect(() => {
    if (selectedRecord) {
      handlerecordDoubleClicked();
    } else {
      handleAddOne();
    }
  }, [selectedRecord]);

  //change No functionality to get that particular record
  const handleKeyDown = async (event) => {
    if (event.key === "Tab") {
      const inputName = event.target.name;
      const inputValue = event.target.value;

      let apiUrl = `${API_URL}/getByDocNo_LetterHead?Company_Code=${companyCode}&DOC_NO=${inputValue}`;

      try {
        const response = await axios.get(apiUrl);
        const data = response.data;
        partyCode = data.letterData.Mill_code;

        if (inputName === "changeNo") {
          setFormData({
            ...formData,
            ...data.letterData,
          });
        } else if (inputName === "copyLetterNo") {
          setFormData({
            ...formData,
            ...data.letterData,
            Letter_No: formData.Letter_No,
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  
const loadLetterHeadData = (letterData) => {
  if (!letterData) {
    console.error("LetterHead data not found");
    return;
  }

  // ===================================
  // PARTY DETAILS
  // ===================================

  partyCode = letterData.Mill_code;

  setParty(letterData.Mill_code);
  setPartyName(letterData.AC_NAME || "");

  // ===================================
  // MAIN LETTERHEAD DETAILS
  // ===================================

  setFormData((prevData) => ({
    ...prevData,
    ...letterData,
  }));

  // ===================================
  // MULTIPLE GRADE DETAILS
  // ===================================

  let gradeDetails = [];

  try {
    const rawGradeDetails =
      letterData.GradeDetailsJson ??
      letterData.gradeDetails ??
      [];

    gradeDetails =
      typeof rawGradeDetails === "string"
        ? JSON.parse(rawGradeDetails)
        : rawGradeDetails;

    if (!Array.isArray(gradeDetails)) {
      gradeDetails = [];
    }
  } catch (error) {
    console.error(
      "Error parsing GradeDetailsJson:",
      error
    );
    gradeDetails = [];
  }

  // ===================================
  // SET MULTIPLE GRADE ROWS
  // ===================================

  if (gradeDetails.length > 0) {
    setGradeRows(
      gradeDetails.map((row) => ({
        grade: row.grade ?? "",
        Quantity: row.Quantity ?? "",
        Rate: row.Rate ?? "",
        Advance: row.Advance ?? "",
        Season: row.Season ?? "",
      }))
    );
  } else {
    // Support older records containing one grade
    setGradeRows([
      {
        grade: letterData.grade ?? "",
        Quantity: letterData.Quantity ?? "",
        Rate: letterData.Rate ?? "",
        Advance: letterData.Advance ?? "",
        Season: letterData.Season ?? "",
      },
    ]);
  }

  console.log("LetterHead:", letterData);
  console.log("Grade Details:", gradeDetails);
};

  //Navigation Buttons
 
const handleFirstButtonClick = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/getFirst_LetterHead`,
      {
        params: {
          Company_Code: companyCode,
        },
      }
    );

    const data = response.data;

    loadLetterHeadData(data.firstLetterData);

  } catch (error) {
    console.error(
      "Error fetching first LetterHead:",
      error.response?.data || error.message
    );
  }
};


  
const handlePreviousButtonClick = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/getPrevious_LetterHead`,
      {
        params: {
          Company_Code: companyCode,
          DOC_NO: formData.Letter_No,
        },
      }
    );

    const data = response.data;

    loadLetterHeadData(data.previousLetterData);

  } catch (error) {
    console.error(
      "Error fetching previous LetterHead:",
      error.response?.data || error.message
    );
  }
};



 
const handleNextButtonClick = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/getNext_LetterHead`,
      {
        params: {
          Company_Code: companyCode,
          DOC_NO: formData.Letter_No,
        },
      }
    );

    const data = response.data;

    loadLetterHeadData(data.nextLetterData);

  } catch (error) {
    console.error(
      "Error fetching next LetterHead:",
      error.response?.data || error.message
    );
  }
};


  const handleAddGradeRow = () => {
  setGradeRows((prev) => [
    ...prev,
    {
      grade: "",
      Quantity: "",
      Rate: "",
      Advance: "",
      Season: "",
    },
  ]);
};

// Update a specific row
const handleGradeRowChange = (index, field, value) => {
  setGradeRows((prev) =>
    prev.map((row, i) =>
      i === index
        ? { ...row, [field]: value }
        : row
    )
  );
};

// Remove a specific row
const handleRemoveGradeRow = (index) => {
  setGradeRows((prev) =>
    prev.filter((_, i) => i !== index)
  );
};

  return (
    <>
      <UserAuditInfo
        createdBy={formData.Created_By}
        modifiedBy={formData.Modified_By}
        title={"Letter"}
      />
      <div style={{ marginTop: "40px" }}>
        <ToastContainer autoClose={500} />
        <ActionButtonGroup
          handleAddOne={handleAddOne}
          addOneButtonEnabled={addOneButtonEnabled}
          handleSaveOrUpdate={handleSaveOrUpdate}
          saveButtonEnabled={saveButtonEnabled}
          isEditMode={isEditMode}
          handleEdit={handleEdit}
          editButtonEnabled={editButtonEnabled}
          handleDelete={handleDelete}
          deleteButtonEnabled={deleteButtonEnabled}
          handleCancel={handleCancel}
          cancelButtonEnabled={cancelButtonEnabled}
          handleBack={handleBack}
          backButtonEnabled={backButtonEnabled}
          component={<div style={{ display: 'flex' }} >
                    {/* <SaleBillReport doc_no={formData.doc_no} disabledFeild={!addOneButtonEnabled} /> */}
                    <LetterHeadReprt doc_no={formData.Letter_No} disabledFeild={!addOneButtonEnabled} />
                    </div>}
        />
        <div>
          <NavigationButtons
            handleFirstButtonClick={handleFirstButtonClick}
            handlePreviousButtonClick={handlePreviousButtonClick}
            handleNextButtonClick={handleNextButtonClick}
            handleLastButtonClick={handleCancel}
            highlightedButton={highlightedButton}
            isEditing={isEditing}
            isFirstRecord={formData.Company_Code === 1}
          />
        </div>
      </div>

    
<div>
  <form>
   
<Box
  sx={{
    width: "100%",
    display: "flex",
    justifyContent: "center",
    px: { xs: 1, sm: 2, md: 3 },
    py: 3,
    boxSizing: "border-box",
  }}
>
  <Box
    sx={{
      width: "100%",
      maxWidth: "1200px",
      p: { xs: 2, sm: 3 },
      bgcolor: "background.paper",
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 2,
      boxShadow: 1,
      boxSizing: "border-box",
      "& .MuiTextField-root": {
        width: "100%",
      },
    }}
  >
    <Grid container spacing={2} alignItems="flex-start">

      {/* =========== ROW 1: LETTER DETAILS =========== */}

      <Grid item xs={12} sm={4} md={3}>
        <TextField
          label="Change No"
          id="changeNo"
          name="changeNo"
          autoComplete="off"
          inputRef={changeNoRef}
          onKeyDown={handleKeyDown}
          disabled={!addOneButtonEnabled}
          fullWidth
          size="small"
        />
      </Grid>

      <Grid item xs={12} sm={4} md={3}>
        <TextField
          label="Letter No"
          id="Letter_No"
          name="Letter_No"
          value={formData.Letter_No ?? ""}
          onChange={handleChange}
          disabled
          fullWidth
          size="small"
        />
      </Grid>

      <Grid item xs={12} sm={4} md={3}>
         <TextField
          label="Letter Date"
          name="Letter_Date"
          id="Letter_Date"
          type="date"
          value={formData.Letter_Date ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
          InputLabelProps={{ shrink: true }}
        />
        {/* <TextField
          label="Letter Date"
          id="Letter_Date"
          name="Letter_Date"
          type="date"
          value={formData.Letter_Date ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
          InputLabelProps={{ shrink: true }}
        /> */}
      </Grid>

      {/* =========== ROW 2: PARTY DETAILS =========== */}

      <Grid item xs={12} md={4}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            width: "100%",
            minHeight: 40,
          }}
        >
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
          >
            Party:
          </Typography>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <AccountMasterHelp
              onAcCodeClick={handleParty}
              CategoryName={party_Name || formData.AC_NAME || ""}
              CategoryCode={party || partyCode}
              name="Mill_code"
              disabledFeild={!isEditing && addOneButtonEnabled}
            />
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12} md={8}>
        <TextField
          label="Party Name"
          id="AC_NAME"
          name="AC_NAME"
          value={party_Name || formData.AC_NAME || ""}
          onChange={(e) => setPartyName(e.target.value)}
          disabled={!isEditing && addOneButtonEnabled}
          fullWidth
          size="small"
        />
      </Grid>

      {/* =========== ROW 2b: MILL (optional, separate from Party) =========== */}

      <Grid item xs={12} md={4}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            width: "100%",
            minHeight: 40,
          }}
        >
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
          >
            Mill:
          </Typography>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <AccountMasterHelp
              onAcCodeClick={handleMill2}
              CategoryName={formData.Mill2_Name}
              CategoryCode={formData.Mill2_Code}
              name="Mill2_Code"
              disabledFeild={!isEditing && addOneButtonEnabled}
            />
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12} md={8}>
        <TextField
          label="Mill Short Name / Gov. Mill Code"
          value={
            [formData.Mill2_Name, formData.Mill2_GovCode && `Gov Code: ${formData.Mill2_GovCode}`]
              .filter(Boolean)
              .join(" — ")
          }
          fullWidth
          size="small"
          InputProps={{ readOnly: true }}
        />
      </Grid>

      {/* =========== ROW 3: ADDRESS =========== */}

      <Grid item xs={12} md={9}>
        <TextField
          label="Address"
          name="ADDRESS"
          id="ADDRESS"
          value={formData.ADDRESS ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <TextField
          label="GST No"
          name="GST_no"
          id="GST_no"
          value={formData.GST_no ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
        />
      </Grid>

      {/* =========== ROW 4: LOCATION =========== */}

      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="City"
          name="CITY"
          id="CITY"
          value={formData.CITY ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Pincode"
          name="PINCODE"
          id="PINCODE"
          value={formData.PINCODE ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="District"
          name="District"
          id="District"
          value={formData.District ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="State"
          name="State"
          id="State"
          value={formData.State ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
        />
      </Grid>

      {/* =========== ROW 5: REFERENCE =========== */}

      <Grid item xs={12} md={3}>
        <TextField
          label="Reference No"
          name="Ref_no"
          id="Ref_no"
          value={formData.Ref_no ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
        />
      </Grid>

      <Grid item xs={12} md={9}>
        <TextField
          label="Subject"
          name="Subject"
          id="Subject"
          value={formData.Subject ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
        />
      </Grid>

      {/* =========== ROW 6: COMMERCIAL DETAILS =========== */}

      
{/* =========== ROW 6: MULTIPLE GRADE DETAILS =========== */}

<Grid item xs={12}>
  <Box
    sx={{
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 2,
      p: 2,
      bgcolor: "#fafafa",
    }}
  >
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 600 }}
      >
        Grade / Quantity / Rate / Advance Details
      </Typography>

      <Button
        variant="contained"
        size="small"
        startIcon={<AddIcon />}
        onClick={handleAddGradeRow}
        disabled={isDisabled}
      >
        Add Row
      </Button>
    </Box>

    {gradeRows.map((row, index) => (
      <Grid
        container
        spacing={2}
        alignItems="center"
        key={index}
        sx={{ mb: 1 }}
      >
        <Grid item xs={12} sm={6} md={2.5}>
          <TextField
            select
            label={`Grade ${index + 1}`}
            value={row.grade ?? ""}
            onChange={(e) =>
              handleGradeRowChange(
                index,
                "grade",
                e.target.value
              )
            }
            disabled={isDisabled}
            fullWidth
            size="small"
            SelectProps={{ native: true }}
          >
            <option value=""></option>
            {gradeOptions.map((g) => (
              <option key={g.systemid} value={g.System_Name_E}>
                {g.System_Name_E}
              </option>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <TextField
            label="Quantity"
            type="number"
            value={row.Quantity ?? ""}
            onChange={(e) =>
              handleGradeRowChange(
                index,
                "Quantity",
                e.target.value
              )
            }
            disabled={isDisabled}
            fullWidth
            size="small"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <TextField
            label="Rate"
            type="number"
            value={row.Rate ?? ""}
            onChange={(e) =>
              handleGradeRowChange(
                index,
                "Rate",
                e.target.value
              )
            }
            disabled={isDisabled}
            fullWidth
            size="small"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <TextField
            label="Advance"
            type="number"
            value={row.Advance ?? ""}
            onChange={(e) =>
              handleGradeRowChange(
                index,
                "Advance",
                e.target.value
              )
            }
            disabled={isDisabled}
            fullWidth
            size="small"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <TextField
            label="Season"
            placeholder="e.g. 2025-26"
            value={row.Season ?? ""}
            onChange={(e) =>
              handleGradeRowChange(
                index,
                "Season",
                e.target.value
              )
            }
            disabled={isDisabled}
            fullWidth
            size="small"
          />
        </Grid>

        <Grid item xs={12} md={1.5}>
          <IconButton
            color="error"
            onClick={() => handleRemoveGradeRow(index)}
            disabled={isDisabled || gradeRows.length === 1}
          >
            <DeleteIcon />
          </IconButton>
        </Grid>
      </Grid>
    ))}
  </Box>
</Grid>

      <Grid item xs={12} sm={6} md={12}>
        <TextField
          label="Note"
          name="Note"
          id="Note"
          value={formData.Note ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
          multiline
          minRows={2}
        />
      </Grid>

      {/* <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Grade"
          name="grade"
          id="grade"
          value={formData.grade ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Quantity"
          name="Quantity"
          id="Quantity"
          type="number"
          value={formData.Quantity ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Rate"
          name="Rate"
          id="Rate"
          type="number"
          value={formData.Rate ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Advance"
          name="Advance"
          id="Advance"
          type="number"
          value={formData.Advance ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
        />
      </Grid> */}

      {/* =========== ROW 7: DATES =========== */}

      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Payment Due Date"
          name="PaymentDue_Date"
          id="PaymentDue_Date"
          type="date"
          value={formData.PaymentDue_Date ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Lifting Due Date"
          name="Lifting_Date"
          id="Lifting_Date"
          type="date"
          value={formData.Lifting_Date ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          label="Commodity"
          name="Commodity"
          id="Commodity"
          value={formData.Commodity ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          size="small"
        />
      </Grid>

      {/* =========== ROW 8: TERMS =========== */}

      <Grid item xs={12} md={6}>
        <TextField
          label="Specification"
          name="Specification"
          id="Specification"
          value={formData.Specification ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          multiline
          minRows={2}
          size="small"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          label="Delivery Terms"
          name="Delivery_terms"
          id="Delivery_terms"
          value={formData.Delivery_terms ?? ""}
          onChange={handleChange}
          disabled={isDisabled}
          fullWidth
          multiline
          minRows={2}
          size="small"
        />
      </Grid>

    </Grid>
  </Box>
</Box>

  </form>
</div>

      {isLoading && (
        <div className="loading-overlay">
          <div className="spinner-container">
            <SaveUpdateSpinner />
          </div>
        </div>
      )}
    </>
  );
};

export default LetterHead;
